import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const AUTH_API_BASE = `${API_ROOT}/api/auth`;

export default function Login() {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [modules, setModules] = useState([]);
  const [moduleId, setModuleId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const moduleHoverText = modules.length
    ? modules.map((m) => m.Module).join("\n")
    : "Enter a valid 10-digit mobile number to load modules";

  // Fetch modules after mobile entered
  const fetchModules = async () => {
    if (mobile.length !== 10) {
      setModules([]);
      return;
    }

    try {
      const res = await fetch(`${AUTH_API_BASE}/modules?mobile=${mobile}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to fetch modules");
      }

      setModules(Array.isArray(data) ? data : []);
      setError("");
    } catch (err) {
      setModules([]);
      setError(err.message || "Failed to fetch modules");
    }
  };

  const ensureModulesLoaded = async () => {
    if (mobile.length === 10 && modules.length === 0) {
      await fetchModules();
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${AUTH_API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile, password, moduleId }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        return;
      }

      // store user session
      const moduleName = modules.find((m) => String(m.ModuleID) === String(moduleId))?.Module || "";
      localStorage.setItem("user", JSON.stringify({ ...data, moduleName }));
      const resolvedModuleId = parseInt(data?.moduleId, 10);
      const target = [1, 3, 7, 13, 16, 19].includes(resolvedModuleId)
        ? "/profile"
        : resolvedModuleId === 10
          ? "/guesthouse/pending-bookings"
          : resolvedModuleId === 9
            ? "/resolver-complaint-list"
            : "/dashboard";
      navigate(target);
    } catch (err) {
      setError(err.message || "Failed to connect to server");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>Login</h1>
          <p>Access your Professional dashboard</p>
        </div>

        {error && (
          <div className="login-error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-field">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              id="mobile"
              type="tel"
              maxLength={10}
              placeholder="10-digit mobile number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              onBlur={fetchModules}
              required
            />
            <small>Only 10-digit mobile numbers are supported</small>
          </div>

          <div className="login-field">
            <label htmlFor="module">Select Module</label>
            <select
              id="module"
              value={moduleId}
              onChange={(e) => setModuleId(e.target.value)}
              onMouseEnter={ensureModulesLoaded}
              onFocus={ensureModulesLoaded}
              title={moduleHoverText}
              required
            >
              <option value="">-- Select Module --</option>
              {modules.map((m) => (
                <option key={m.ModuleID} value={m.ModuleID}>
                  {m.Module}
                </option>
              ))}
            </select>
          </div>

          <div className="login-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-submit">Login</button>
        </form>
      </div>
    </div>
  );
}
